exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-card {\n    margin-bottom: 10px;\n}\n\na {\n    text-decoration: none;\n    color: #14425f;\n    font-weight: 700;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/thibautjacob/Documents/Projects/Portfolio/src/app/components/company-news/company-news.component.css
// module id = ../../../../../src/app/components/company-news/company-news.component.css
// module chunks = main